module.exports = __webpack_public_path__ + "build/desktop/a/img/transfer.9a8bbd7812bbe7cbb3dddfddada25591.svg";